import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import GitHubLogo from '../github-logo';
import './header.css';

const Header = ({authenticated, signOut, username, PhotoUrl}) => (
  /* jshint ignore:start */
  <header className="header">
    <div className="g-row">
      <div className="g-col">
        <h1 className="header__title">TODO</h1>
        <h1 className="header__credit__name">{authenticated ? <li>Welcome, {username}{PhotoUrl}</li> : null}</h1>
        <ul className="header__actions">
          {authenticated ? <li><Button onClick={signOut}>Sign out</Button></li> : null}
          <li>
            <a className="link link--github" href="https://github.com/r-park/todo-react-redux">
            <GitHubLogo />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
  /* jshint ignore:end */
);

Header.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired,
  username: PropTypes.string,
  PhotoUrl: PropTypes.string
};


export default Header;



// WEBPACK FOOTER //
// ./src/views/components/header/header.js